import plumbingImage from '../../../images/plombier-pro-600x400.jpeg'
export default function Example() {
    return (
      <div className="relative bg-indigo-800">
        <div className="absolute inset-0">
          <img
            className="w-full h-full object-cover"
            src={plumbingImage}
            alt=""
          />
          <div className="absolute inset-0 bg-black opacity-75 mix-blend-multiply" aria-hidden="true" />
        </div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">Débouchage</h1>
          <p className="mt-6 text-xl text-indigo-100 max-w-3xl">
          Belga Service, met ses compétences à votre service, pour tous vos débouchages d’égouts et de canalisation.<br/><br/>
              Nos équipes composées de professionnels, réalisent tous vos travaux de débouchage sur tous types de canalisations.<br/><br/> 
              Notre expérience et nos compétences vous assurent un service sur mesure, alliant efficacité et rapidité d’exécution.<br/><br/>
              Afin de vous garantir des prestations irréprochables, et un résultat optimal, nous utilisons des matériaux professionnel à la pointe de la technologie et des techniques de qualité.<br/><br/>
              De plus, nous intervenons 7j/7 et 24h/24 pour vos urgences! Faites-appel à Belga Service ! <a href="tel:0032470178102" className='inline-block animate-beating text-blue-500'>0470/17.81.02</a>
          </p>
        </div>
      </div>
    )
  }
  